import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo, logoUrl } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-neutral-950 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-[7.6923%] py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src={logoUrl}
              alt="Nexline Electrical"
              className="h-12 w-auto mb-6"
            />
            <p className="text-neutral-400 max-w-md mb-6">
              Canada's elite residential and commercial electrical contractor. 
              Delivering precision, safety, and excellence from coast to coast.
            </p>
            <div className="flex items-center gap-4">
              <a
                href={companyInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/5 hover:bg-electric-yellow text-white hover:text-black transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {[
                'Residential Electrical',
                'Commercial Electrical',
                'Panel Upgrades',
                'EV Charger Installation',
                'Maintenance & Repairs'
              ].map((link) => (
                <li key={link}>
                  <a 
                    href="#services"
                    className="text-neutral-400 hover:text-electric-yellow transition-colors duration-300"
                  >
                    {link}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/blog"
                  data-testid="footer-blog-link"
                  className="text-neutral-400 hover:text-electric-yellow transition-colors duration-300"
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center gap-3 text-neutral-400 hover:text-electric-yellow transition-colors duration-300"
                >
                  <Phone size={16} className="text-electric-yellow" />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-neutral-400 hover:text-electric-yellow transition-colors duration-300"
                >
                  <Mail size={16} className="text-electric-yellow" />
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-neutral-400">
                <MapPin size={16} className="text-electric-yellow mt-1" />
                <span>{companyInfo.coverage}</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-neutral-500">
            <Link to="/privacy-policy" data-testid="footer-privacy-policy-link" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" data-testid="footer-terms-of-service-link" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
